<template>
  <div>
    <!--    <carousel-->
    <!--      :autoplay="true"-->
    <!--      :loop="true"-->
    <!--      :autoplayTimeout="7000"-->
    <!--      :autoplayHoverPause="true"-->
    <!--      :perPage="1"-->
    <!--      :paginationEnabled="true"-->
    <!--      ref="carousel"-->
    <!--    >-->
    <!--      <slide v-for="item in sliderProducts" :key="item.id">-->
    <!--        <div class="bg-local" :style="`height: 450px; background-image: url('${getImage(item, 450)}'); background-position: center; background-repeat: no-repeat; background-size: cover;`">-->
    <!--            <div class="flex flex-col justify-end h-full">-->
    <!--              <vs-spacer class="flex"/>-->
    <!--              <div class="flex justify-center flex-wrap">-->
    <!--                <vs-button class="mt-4 mr-2 shadow-lg" size="large" type="gradient" color="success" icon-pack="feather" icon="icon-shopping-bag" :to="{ name: 'item-detail-view', params: { item: item.productId } }">Pedir</vs-button>-->
    <!--              </div>-->
    <!--              <p class="my-4 mx-4 p-4 rounded-lg text-bold" style="background-color: #F5F5F5;">{{ item.description }}</p>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--      </slide>-->
    <!--    </carousel>-->
    <div class="relative flex flex-wrap items-center mb-4 h-xs sm:h-sm md:h-md lg:h-lg xl:h-xl" v-if="sliderProducts.length > 0">
      <div class="absolute left-0 z-40 h-full flex items-center">
        <vs-icon class="flex-1 cursor-pointer" icon="keyboard_arrow_left" size="75px" @click="clickSlider(-1)"/>
      </div>
      <transition-group class="w-full items-center h-full relative" name="slide-fade" tag="div">
        <div class="w-full items-center h-full absolute z-0" v-for="(item, index) in sliderProducts" :key="item.sequence" v-show="index == sliderIndex">
          <div class="bg-local h-full flex justify-center bg-cover bg-center bg-no-repeat" :style="`background-image: url('${getSliderImage(item, getSliderHeight())}');`">
            <div class="flex flex-col justify-end h-full">
              <vs-spacer class="flex"/>
              <p class="hidden md:block my-4 mx-4 p-4 rounded-lg text-bold" style="background-color: #F5F5F5;" v-if="item.description != ''">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </transition-group>
      <div class="absolute right-0 z-40 h-full flex items-center">
        <vs-icon class="flex-1 cursor-pointer" icon="keyboard_arrow_right" size="75px" @click="clickSlider(1)"/>
      </div>
    </div>
    <div class="flex w-full flex-col items-center justify-center mb-2">
      <div class="flex flex-row w-full items-center justify-center">
        <div class="flex w-full sm:w-2/5 flex-row items-center justify-between">
          <div class="flex flex-col w-1/3 items-center">
            <div class="flex flex-col items-center bg-success p-2 rounded-full">
              <vs-icon icon="local_shipping" size="large" bg="success" color="white" round/>
            </div>
          </div>
          <a href="https://sbiblica.org" target="_blank" class="flex flex-col w-1/3 items-center cursor-pointer">
            <div class="flex flex-col items-center bg-success p-2 rounded-full">
              <feather-icon icon="HeartIcon" svgClasses="h-12 w-12 fill-current text-white"/>
            </div>
          </a>
          <div class="relative flex flex-col w-1/3 items-center cursor-pointer" @click="contactSelected = !contactSelected">
            <div class="flex flex-col items-center justify-center bg-success p-3 rounded-full">
              <!--              <vs-icon vs-icon-pack="fa" icon="icon-whatsapp" color="white" size="large"/>-->
              <font-awesome-icon :icon="whatsappIcon" class="h-12 w-12" color="white"/>
            </div>
            <div class="flex flex-col w-full bg-white absolute inline-block z-50" style="top: 7rem;" v-if="contactSelected" @click="contactSelected = false">
              <span class="p-1 bg-success text-center text-white text-xs sm:text-md"><b>Guatemala</b></span>
              <a href="https://wa.me/50259789090" target="_blank" class="flex justify-center items-center mb-1 px-2 pb-2 bg-success">
                <div class="flex flex-col">
                  <div class="text-white text-xs sm:text-md">+502 5978 9090</div>
                </div>
              </a>
              <span class="p-1 bg-success text-center text-white text-xs sm:text-md"><b>Quetzaltenango</b></span>
              <a href="https://wa.me/50256211095" target="_blank" class="flex justify-center items-center px-2 pb-2 bg-success">
                <div class="flex flex-col">
                  <div class="text-white text-xs sm:text-md">+502 5621 1095</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row w-full items-center justify-center mb-2">
        <div class="flex w-full sm:w-2/5 flex-row items-center justify-between">
          <div class="flex flex-col w-1/3 items-center text-primary p-2 sm:text-lg">
            Ver pedido
          </div>
          <a href="https://sbiblica.org" target="_blank" class="flex flex-col w-1/3 items-center text-primary text-xs sm:text-sm text-center cursor-pointer">
            Al comprar apoya a nuestros proyectos misioneros
          </a>
          <div class="flex flex-col w-1/3 items-center text-primary sm:text-lg cursor-pointer">
            Contacto
          </div>
        </div>
      </div>
    </div>

    <showcase class="mb-6"/>

    <promotions
      class="flex w-full items-center justify-center mb-6"
      :list="{ products: $store.getters.promotionProducts, title: $store.state.promotions.title }"
      v-if="loaded"
    />

    <div class="flex justify-center items-center mb-6 relative" :style="`max-height: '${getBlogHeight}px' !important;`" v-if="$store.state.blog.active">
      <img class="w-full" :src="getBlogImage()"/>
      <div class="absolute" style="top: 5px; left: 5px;">
        <div class="text-white text-xl sm:text-3xl"><b>{{ $store.state.blog.title }}</b></div>
        <div class="text-white text-lg sm:text-xl">{{ $store.state.blog.subtitle }}</div>
        <div class="text-white sm:text-lg"><i>{{ $store.state.blog.description }}</i></div>
      </div>
      <a :href="$store.state.blog.url" target="_blank" class="sm:border sm:border-solid sm:border-white text-white text-xs xl:text-2xl text-center items-center p-1 lg:p-3 absolute" style="top: 80%; left: 50%; transform: translate(-80%, -50%)">Ir al blog</a>
<!--      <a :href="$store.state.blog.url" target="_blank" class="block lg:hidden text-sm text-white text-center items-center absolute" style="top: 75%; left: 50%; transform: translate(-75%, -50%)">Ir al blog</a>-->
    </div>

    <categories class="mb-6"/>

    <promotions class="flex w-full items-center justify-center mb-6" :list="$store.state.seasonal"/>
<!--    <div class="flex justify-center bg-cover bg-center bg-repeat-x mb-4" :style="`background-image: url('${getRibbonImage()}'); height: ${getRibbonHeight()}px;`"/>-->

    <div class="flex justify-center mb-5">
      <img class="w-full" :src="getRibbonImage()" :height="getRibbonHeight"/>
    </div>

    <promotions
      class="flex w-full items-center justify-center mb-6"
      :list="{ products: $store.getters.sliderCategories, title: $store.state.sliderCategories.title }"
      v-if="loaded"
    />

  </div>
</template>

<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';

export default {
  data() {
    return {
      loaded: false,
      whatsappIcon: faWhatsapp,
      sliderIndex: 0,
      sliderInterval: null,
      timeoutSliderInterval: 10,
      screens: [
        {min: 0, max: 575, height: 120, ribbonHeight: 60, blogHeight: 60},     // xs
        {min: 576, max: 767, height: 185, ribbonHeight: 90, blogHeight: 90},   // sm
        {min: 768, max: 991, height: 250, ribbonHeight: 125, blogHeight: 125},   // md
        {min: 992, max: 1199, height: 330, ribbonHeight: 165, blogHeight: 165},  // lg
        {min: 1200, max: 1399, height: 400, ribbonHeight: 200, blogHeight: 200}, // xl
        {min: 1400, max: 1599, height: 480, ribbonHeight: 240, blogHeight: 240}, // 1xl (antes 480)
        {min: 1600, max: 8000, height: 535, ribbonHeight: 270, blogHeight: 270}  // xxl (antes 535)
      ],
      contactSelected: false
    }
  },
  components: {
    FontAwesomeIcon,
    Showcase: () => import('./components/ShowcaseSplide'),
    Promotions: () => import('./components/PromotionsSplide'),
    Categories: () => import('./components/CategoriesSplide')
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    imageHeight() {
      if (this.windowWidth < 400) {
        return 175;
      } else if (this.windowWidth < 600) {
        return 200;
      } else {
        return 300;
      }
    },
    viewPort() {
      return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    },
    innerWidth() {
      return (window.innerWidth || 0);
    },
    publicKey() {
      return this.$store.getters['getParameter']('imagekit').publicKey;
    },
    urlEndpoint() {
      return this.$store.getters['getParameter']('cloudinary').url;
    },
    showcaseTitle() {
      return this.$store.getters['getParameter']('showcase').title;
    },
    ribbonImage1() {
      return this.$store.getters['getParameter']('images').ribbon1;
    },
    blogImage() {
      return this.$store.state.blog.imageURL;
    },
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    styleSliderHeight() {
      return {height: `${this.getSliderHeight()}px;`};
    },
    sliderProducts() {
      if (this.$store.state.sliderProducts) {
        if (this.$store.state.sliderProducts.list) {
          return this.$store.state.sliderProducts.list.filter(item => item.status == 'ACT').sort(function (a, b) {
            var ret = 1;
            if (a.sequence < b.sequence) {
              ret = -1;
            }
            return ret;
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    showcaseProducts() {
      if (this.$store.state.showcaseProducts) {
        if (this.$store.state.showcaseProducts.list) {
          return [...this.$store.state.showcaseProducts.list].sort(function (a, b) {
            var ret = 1;
            if (a.sequence < b.sequence) {
              ret = -1;
            }
            return ret;
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    visibleShowcaseProducts() {
      return this.getVisibleShowcaseProducts();
    },
    showcaseProduct1() {
      return this.showcaseProducts[0];
    },
    showcaseProduct2() {
      return this.showcaseProducts[1];
    },
    showcaseProduct3() {
      return this.showcaseProducts[2];
    },
    promotionsTitle() {
      if (this.$store.state.promotions) {
        return this.$store.state.promotions.title;
      } else {
        return '';
      }
    }
  },
  methods: {
    clickSlider(step) {
      clearInterval(this.sliderInterval);
      this.changeSlider(step);
      var self = this;
      this.sliderInterval = setInterval(() => {
        self.changeSlider(1);
      }, this.timeoutSliderInterval * 1000)
    },
    changeSlider(step) {
      if (this.sliderProducts.length > 0) {
        if (step > 0) {
          if ((this.sliderIndex + 1) >= this.sliderProducts.length) {
            this.sliderIndex = 0;
          } else {
            this.sliderIndex++;
          }
        } else if (step < 0) {
          if (this.sliderIndex <= 0) {
            this.sliderIndex = this.sliderProducts.length - 1;
          } else {
            this.sliderIndex--;
          }
        }
      }
    },
    getSliderHeight() {
      var height = 300;
      var screen = this.screens.find(s => s.max >= this.viewPort);
      if (screen) {
        height = screen.height;
      }
      return height;
    },
    getSliderImage(item, height) {
      let imageURL = '';
      if (item && height) {
        if (item.hasOwnProperty('imageURL')) {
          const image = item.imageURL.split('.');
          imageURL = [this.imagesURL, '/slider%2F', image[0], '@', height, '.', image[1], '?alt=media'].join('');
        }
      }
      return imageURL;
    },
    getRibbonHeight() {
      var height = 60;
      var screen = this.screens.find(s => s.max >= this.viewPort);
      if (screen) {
        height = screen.ribbonHeight;
      }
      return height;
    },
    getRibbonImage() {
      let imageURL = '';
      if (this.ribbonImage1) {
        const image = this.ribbonImage1.split('.');
        imageURL = [this.imagesURL, '/ribbons%2F', image[0], '@', this.getRibbonHeight(), '.', image[1], '?alt=media'].join('');
      }
      return imageURL;
    },
    getBlogHeight() {
      var height = 100;
      var screen = this.screens.find(s => s.max >= this.viewPort);
      if (screen) {
        height = screen.blogHeight;
      }
      return height;
    },
    getBlogImage() {
      let imageURL = '';
      if (this.blogImage) {
        const image = this.blogImage.split('.');
        imageURL = [this.imagesURL, '/blog%2F', image[0], '@', this.getBlogHeight(), '.', image[1], '?alt=media'].join('');
      }
      return imageURL;
    },
    getProductImage(item, height) {
      const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.png?alt=media'].join('');
      return imageURL;
    },
    openProduct(product) {
      if (product.productId != '') {
        this.$router.push({name: 'item-detail-view', params: {item: product.productId}}).catch(() => {
        });
      }
    },
    getProduct(showcase) {
      let product = {onSale: false, price: 0, salePrice: 0, originalPrice: 0}
      if (showcase.productId != '') {
        product = this.$store.getters.getProduct(showcase.productId);
      }
      return product;
    },
    changeContactSelected() {
      this.contactSelected = !this.contactSelected;
    }
  },
  mounted() {
    this.loaded = true;
    var self = this;
    this.sliderInterval = setInterval(() => {
      self.changeSlider(1);
    }, this.timeoutSliderInterval * 1000)
  }
}
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .8s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
